import { render, staticRenderFns } from "./member-card-bg-mark.vue?vue&type=template&id=2a9bd87a&scoped=true"
import script from "./member-card-bg-mark.vue?vue&type=script&lang=js"
export * from "./member-card-bg-mark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9bd87a",
  null
  
)

export default component.exports